import { render, staticRenderFns } from "./LastPlace.vue?vue&type=template&id=7b6ccc7a&scoped=true&"
import script from "./LastPlace.vue?vue&type=script&lang=js&"
export * from "./LastPlace.vue?vue&type=script&lang=js&"
import style0 from "./LastPlace.vue?vue&type=style&index=0&id=7b6ccc7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6ccc7a",
  null
  
)

export default component.exports